import fontStyles from 'styles/Fonts.module.scss';
import FormOrRedirectButton from 'components/landing/home-landing/form-or-redirect-button/form-or-redirect-button';
import hipotecario from 'static/img/hipotecario_seguros.svg';
import Image from 'core/image';
import LandingSection from 'components/landing/components/landing-section';
import PriceTagItem from 'components/landing/tables/components/price-tag/price-tag-item';
import productHome from 'static/img/additional-product-home.png';
import PropTypes from 'prop-types';
import styles from 'styles/InsuranceResult.module.scss';
import Title from 'core/title';
import { useTranslations } from 'next-intl';
import variables from 'styles/variables.module.scss';

const InsuranceResult = ({ seoKeyword, culture }) => {
    const t = useTranslations('insurance-result');

    return (
        <LandingSection>
            <Title content={t('title')} align />
            <Title content={t('subtitle')} titleType="subtitle" align />
            <div className={styles.container}>
                <div className={styles.product_container}>
                    <Image src={hipotecario} alt={t('company-image-alt')} width={140} height={30} />
                    <p className={fontStyles.text_extra_small_bold}>{seoKeyword}</p>
                </div>
                <div className={styles.price_container}>
                    <div className={styles.discount_container}>
                        <PriceTagItem
                            lineThrough
                            value={t('original-price')}
                            fontSize={15}
                            backgroundColor={variables.grayLighterColor}
                            color={variables.whiteColor}
                        />
                        <PriceTagItem
                            tagType="percentage"
                            value={t('discount-percentage')}
                            fontSize={20}
                            backgroundColor={variables.primaryColor}
                            color={variables.whiteColor}
                        />
                    </div>
                    <p className={fontStyles.text_normal}>{t('final-price')}</p>
                </div>
                <div className={styles.image_container}>
                    <Image src={productHome} alt={t('product-image-alt')} width={500} height={100} />
                </div>
                <FormOrRedirectButton
                    label={t('button.label')}
                    redirectWithConversio={culture === 'es-ar'}
                    compact
                />
            </div>
        </LandingSection>
    );
};

InsuranceResult.propTypes = {
    seoKeyword: PropTypes.string,
    culture: PropTypes.string
};

export default InsuranceResult;
